// src/hooks/useInitializeApp.js
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initializeAuth } from "../redux/slices/authSlice";
import { fetchMyData, clearMyData } from "../redux/slices/myDataSlice";
import { checkTokenExpiry } from "./cookies";

const useInitializeApp = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        checkTokenExpiry();
        dispatch(initializeAuth());
        if (auth.isLoggedIn) {
          await dispatch(fetchMyData());
        } else {
          dispatch(clearMyData());
        }
      } catch (error) {
        console.error("Error during app initialization:", error);
      }
    };

    initializeApp();
  }, [dispatch, auth.isLoggedIn]);
};

export default useInitializeApp;
